import React from "react";
import { LOCALE_STRINGS } from "constants/locales";
import screenshot from "assets/images/Screenshot-compressed.png";
import { joinClassNames } from "helpers/joinClassNames";
import { GetStartedButtonWithModal } from "pages/Home/components/GetStartedButtonWithModal";

const LINK_TO_VIDEO = "https://vantage-360-landing-content.s3.af-south-1.amazonaws.com/Main+homepage+video.mp4";

export const HeroSection = ({
    language = 'EN',
    titleKey,
    getStarted,
    showFooter,
    descriptionKey,
    imageSrc = '',
    showVideo = false,
    className = '',
    showStarted = false,
    containerClassName = ''
}) => {

    const seeHowItWorksText = LOCALE_STRINGS[language]?.seeHowItWorks || "See how it works";

    return (
        <section className={joinClassNames("home-page__heroSection", containerClassName)}>
            {showVideo ? (
                <video className="home-page__heroSection__video" poster={screenshot} autoPlay muted loop playsInline>
                    <source src={LINK_TO_VIDEO} type="video/mp4"/>
                </video>
            ) : (
                <img
                    className="home-page__heroSection__video"
                    src={imageSrc || screenshot}
                    alt=""
                />
            )}
            
            <div className="home-page__heroSection__video-overlay"></div>

            <div className={joinClassNames(
                "home-page__heroSection__info",
                showStarted ? '' : 'hero-padding',
                className
            )}>
                <h1 className="home-page__heroSection__title">
                    {LOCALE_STRINGS[language]?.[titleKey] || titleKey}
                </h1>
                <p className="home-page__heroSection__description">
                    {LOCALE_STRINGS[language]?.[descriptionKey] || descriptionKey}
                </p>
                {showStarted && (
                    <GetStartedButtonWithModal 
                        getStarted={getStarted} 
                        className="text-black"
                    />
                )}
            </div>

            {showFooter && (
                <div className="home-page__heroSection__footer">
                    <div  className="home-page__heroSection__scroll">
                        <svg className="home-page__heroSection__scroll-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 5v14M19 12l-7 7-7-7"/>
                        </svg>

                        <span className="home-page__heroSection__scroll-text">
                            {seeHowItWorksText}
                        </span>

                        <svg className="home-page__heroSection__scroll-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 5v14M19 12l-7 7-7-7"/>
                        </svg>
                    </div>
                </div>
            )}
        </section>
    );
};